import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import { useState } from "react";
import CssClass from "../../../Styles/common.module.css";
import UserActivator from "./UserActivator";
import UserModify from "./UserModify";
import UserUnlock from "./UserUnlock";
import UserResetPassword from "./UserResetPassword";
import UserDelete from "./UserDelete";
import edit from "../../../assets/edit-icon.png";
import lock from "../../../assets/lock-icon.png";
import unlock from "../../../assets/unlock-icon.png";
import resetPass from "../../../assets/reset-pass-icon.png";
import sysAuth from "../../../assets/shield-icon.png";
import deleteIcon from "../../../assets/delete-icon.png";
import moment from "moment";

const UserListTable = (props) => {
  //#region React Hooks
  const [showEdit, setShowEdit] = useState(false);
  const [showActivator, setShowActivator] = useState(false);
  const [showUnlock, setShowUnlock] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [editData, setEditData] = useState([]);
  //#endregion

  const onShowEmailAlertHandler = (e, row) => {
    let functionName = "onShowEmailAlertHandler";

    try {
      functionName = onShowEmailAlertHandler.name;

      window
        .open(common.c_getWebUrl() + "SystemAuthority?_userId=" + row.USER_ID)
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  //#region Modal Show/Hide
  const showEditModal = (e, row) => {
    setShowEdit(!showEdit);
    setEditData(row);
  };

  const hideEditModal = () => {
    setShowEdit(!showEdit);
    setEditData(null);
  };

  const showActivatorModal = (e, row) => {
    setShowActivator(!showActivator);
    setEditData(row);
  };

  const hideActivatorModal = () => {
    setShowActivator(!showActivator);
    setEditData(null);
  };

  const showUnlockModal = (e, row) => {
    setShowUnlock(!showUnlock);
    setEditData(row);
  };

  const hideUnlockModal = () => {
    setShowUnlock(!showUnlock);
    setEditData(null);
  };

  const showResetPasswordModal = (e, row) => {
    setShowResetPassword(!showResetPassword);
    setEditData(row);
  };

  const hideResetPasswordModal = () => {
    setShowResetPassword(!showResetPassword);
    setEditData(null);
  };

  const showDeleteModal = (e, row) => {
    setShowDelete(!showDelete);
    setEditData(row);
  };

  const hideDeleteModal = () => {
    setShowDelete(!showDelete);
    setEditData(null);
  };
  //#endregion

  //#region column
  const columns = [
    // {
    //   accessorKey: "USER_ID",
    //   header: "User ID",
    // },
    {
      accessorKey: "USER_FULL_NAME",
      header: "Full Name",
    },
    {
      accessorKey: "USER_SHORT_NAME",
      header: "Username",
    },
    {
      accessorKey: "EMAIL",
      header: "Email",
    },
    {
      accessorKey: "ORG_NAME",
      header: "ORG Name",
    },
    {
      accessorKey: "ROLE_NAME",
      header: "User Role",
    },
    {
      accessorKey: "LAST_ACCESS_DATETIME",
      header: "Last Access Date Time",
      Cell: ({ cell }) =>
        cell.getValue() === "0001-01-01T00:00:00"
          ? "-"
          : moment(cell.getValue()).format("DD/MM/YYYY hh:mm A"),
    },
    {
      id: "ACTIVE_STATUS",
      header: "Active Status",
      size: 80,
      accessorFn: (row) => {
        const className =
          row.ACTIVE_STATUS === "Active"
            ? CssClass.activeStatus
            : CssClass.inactiveStatus;

        const handleActivatorClick = (e, row) => {
          showActivatorModal(e, row);
        };

        return (
          <div className={CssClass.toggleWrapper}>
            {/* <span className={className}>{row.ACTIVE_STATUS}</span> */}
            <label className={CssClass.switch}>
              <input
                type="checkbox"
                checked={row.ACTIVE_STATUS === "Active"}
                onChange={(e) => handleActivatorClick(e, row)}
              />
              <span className={CssClass.sliderRound}></span>
            </label>
          </div>
        );
      },
    },
    {
      id: "LOCK_STATUS",
      header: "Lock Status",
      size: 80,
      accessorFn: (row) => {
        const className =
          row.LOCK_STATUS === "Not Locked"
            ? CssClass.unlockStatus
            : CssClass.lockStatus;
        return <span className={className}>{row.LOCK_STATUS}</span>;
      },
    },
    // {
    //   accessorKey: "UPDATE_ID",
    //   header: "Last Update By",
    //   size: 120,
    // },
    {
      accessorKey: "UPDATE_NAME",
      header: "Last Update By",
      size: 120,
    },
    {
      accessorKey: "UPDATE_DATETIME",
      header: "Last Update Date Time",
      size: 200,
      Cell: ({ cell }) =>
        cell.getValue() === "0001-01-01T00:00:00"
          ? "-"
          : moment(cell.getValue()).format("DD/MM/YYYY hh:mm A"),
    },
    {
      id: "Action",
      header: "Action",
      size: 30,
      classes: CssClass.tdBtnActionWrapper,
      accessorFn: (row) => (
        <div>
          <span>
            <span title="Modify">
              <Comp.Button
                id="btnEdit"
                type="general"
                onClick={(e) => showEditModal(e, row)}
                style={{ width: "60px", height: "40px" }}
              >
                <img src={edit} alt="Edit" style={{ width: "22px", height: "22px" }} />
              </Comp.Button>
            </span>
            {/* <span title="Activator">
              <Comp.Button
                id="btnActivator"
                type="activator"
                onClick={(e) => showActivatorModal(e, row)}
                style={{ width: "60px", height: "40px" }}
              >
              </Comp.Button>
            </span> */}
            <span title={row.LOCK_STATUS === "Not Locked" ? "Lock" : "Unlock"}>
              <Comp.Button
                id="btnUnlock"
                type="general"
                onClick={(e) => showUnlockModal(e, row)}
                style={{ width: "60px", height: "40px" }}
              >
                <img
              src={row.LOCK_STATUS === "Not Locked" ? unlock : lock}
              alt={row.LOCK_STATUS === "Not Locked" ? "Lock" : "Unlock"}
              style={{ width: "24px", height: "24px" }}
            />
              </Comp.Button>
            </span>
            <span title="Reset Password">
              <Comp.Button
                id="btnEdit"
                type="general"
                onClick={(e) => showResetPasswordModal(e, row)}
                style={{ width: "60px", height: "40px" }}
              >
                <img src={resetPass} alt="Edit" style={{ width: "24px", height: "24px" }} />
              </Comp.Button>
            </span>
            <span title="System Authority">
              <Comp.Button
                id="btnSystemAuthority"
                type="general"
                onClick={(e) => onShowEmailAlertHandler(e, row)}
                // onClick={(e) => onShowEmailAlertHandler(e, row)}
                style={{ width: "60px", height: "40px" }}
              >
                <img src={sysAuth} alt="Edit" style={{ width: "24px", height: "24px" }} />
              </Comp.Button>
            </span>
            <span title="Delete">
              <Comp.Button
                id="btnDelete"
                type="delete"
                onClick={(e) => showDeleteModal(e, row)}
                style={{ width: "60px", height: "40px" }}
              >
                <img src={deleteIcon} alt="Unlock" style={{ width: "26px", height: "26px" }} />
              </Comp.Button>
            </span>
          </span>
        </div>
      ),
    },
  ];
  //#endregion

  return (
    <>
      <Comp.Table
        columns={columns}
        data={props.data}
        table-layout={"auto"}
        enableStickyHeader
        invisibleCol={{
          Action: props.actionAuthority.WRITE !== "Y" ? false : true,
        }}
      />
      <UserModify
        page={props.page}
        showHide={showEdit}
        editData={editData}
        dataToBeSelect={props.dataToBeSelect}
        onHide={hideEditModal}
        onReload={props.onReload}
        onLoading={props.onLoading}
      />
      <UserActivator
        page={props.page}
        showHide={showActivator}
        editData={editData}
        onHide={hideActivatorModal}
        onReload={props.onReload}
        onLoading={props.onLoading}
      />
      <UserUnlock
        page={props.page}
        showHide={showUnlock}
        editData={editData}
        onHide={hideUnlockModal}
        onReload={props.onReload}
        onLoading={props.onLoading}
      />
      <UserResetPassword
        page={props.page}
        showHide={showResetPassword}
        editData={editData}
        onHide={hideResetPasswordModal}
        onReload={props.onReload}
        onLoading={props.onLoading}
      />
      <UserDelete
        page={props.page}
        showHide={showDelete}
        editData={editData}
        onHide={hideDeleteModal}
        onReload={props.onReload}
        onLoading={props.onLoading}
      />
    </>
  );
};

export default UserListTable;
